export default function BarcraftLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 95 37.1739"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="BARCRAFT"
    >
      <rect width="5.89563" height="37.1067" fill="#EC2027" />
      <path
        d="M16.414 12.9739C18.2229 12.9739 19.6298 14.4528 19.6298 16.2006V20.8389C19.6298 22.2506 18.8928 23.5278 17.6199 24.1328C18.8258 24.6033 19.6298 25.8133 19.6298 27.0906V33.88C19.6298 35.695 18.1559 37.1067 16.414 37.1067H10.9203V12.9067H16.414V12.9739ZM17.4189 20.7045V16.2006C17.4189 15.6628 17.0169 15.2595 16.481 15.1922H13.2652V22.99H15.61C16.9499 23.0572 17.4189 22.0489 17.4189 20.7045ZM13.2652 34.8884H16.414C16.9499 34.8884 17.3519 34.485 17.3519 33.9472V26.8889C17.3519 25.3428 16.615 25.1411 15.342 25.1411H13.2652V34.8884Z"
        fill="currentColor"
      />
      <path
        d="M21.7066 37.1067L24.9894 12.9739H29.0762L32.359 37.1739H30.0811L29.0762 30.0484H25.0564L24.0515 37.1739L21.7066 37.1067ZM26.9323 15.1922L25.2574 27.8972H28.8082L27.1333 15.1922H26.9323Z"
        fill="currentColor"
      />
      <path
        d="M39.5275 12.9739C41.2694 12.9739 42.7433 14.4528 42.7433 16.2006V20.9733C42.8103 22.3178 42.0063 23.595 40.7334 24.1328C41.9393 24.4017 42.8103 25.4772 42.7433 26.6872V37.1739H40.4654V26.8889C40.5994 26.0822 39.9965 25.2756 39.1925 25.1411C39.0585 25.1411 38.9245 25.1411 38.7905 25.1411H36.7137V37.1067H34.4358V12.9067H39.5275V12.9739ZM38.4556 23.0572C39.8625 23.0572 40.5324 22.3178 40.5324 20.8389V16.2006C40.5324 15.6628 40.0635 15.1922 39.5275 15.1922H36.7137V23.0572H38.4556Z"
        fill="currentColor"
      />
      <path
        d="M51.1848 16.2006C51.1848 15.6628 50.7828 15.1922 50.2468 15.1922H48.7059C48.17 15.1922 47.768 15.6628 47.768 16.2006V33.88C47.768 34.4178 48.17 34.8884 48.7059 34.8884H50.2468C50.7828 34.8884 51.1848 34.485 51.1848 33.9472V30.25H53.4626V33.9472C53.4626 35.7622 52.0557 37.1739 50.2468 37.1739H48.7729C46.964 37.1739 45.5571 35.695 45.5571 33.9472V16.2006C45.5571 14.3856 47.031 12.9739 48.7729 12.9739H50.2468C52.0557 12.9739 53.4626 14.4528 53.4626 16.2006V18.8895H51.1848V16.2006Z"
        fill="currentColor"
      />
      <path
        d="M61.3681 12.9739C63.177 12.9739 64.5839 14.4528 64.5839 16.2006V20.9733C64.6509 22.3178 63.847 23.595 62.574 24.1328C63.78 24.3345 64.6509 25.4772 64.5839 26.6872V37.1739H62.306V26.8889C62.44 26.0822 61.8371 25.2756 61.0331 25.1411C60.8991 25.1411 60.7651 25.1411 60.6312 25.1411H58.5543V37.1067H56.2764V12.9067H61.3681V12.9739ZM60.2292 23.0572C61.6361 23.0572 62.306 22.3178 62.306 20.8389V16.2006C62.306 15.6628 61.8371 15.1922 61.3011 15.1922H58.4873V23.0572H60.2292Z"
        fill="currentColor"
      />
      <path
        d="M66.6608 37.1067L69.9436 12.9739H74.0303L77.3131 37.1739H75.0353L74.0303 30.0484H70.0106L69.0056 37.1739L66.6608 37.1067ZM71.8865 15.1922L70.2116 27.8972H73.7623L72.0875 15.1922H71.8865Z"
        fill="currentColor"
      />
      <path
        d="M81.6009 15.2595V23.0572H85.3526V25.1411H81.6009V37.1067H79.323V12.9739H85.8886V15.2595H81.6009Z"
        fill="currentColor"
      />
      <path
        d="M92.1862 15.2595V37.1739H89.9083V15.2595H87.0945V12.9739H94.933V15.2595H92.1862Z"
        fill="currentColor"
      />
    </svg>
  );
}
